import { authHooks, authPages } from "@app/auth";
import { Show } from "@ui";
import { AuthenticatedRoutes } from "./AuthenticatedRoutes";
import { UnauthenticatedRoutes } from "./UnauthenticatedRoutes";

export function Routes() {
    const auth = authHooks.useAuth();

    if (auth?.two_factor_setup_required) {
        return <authPages.TwoFactorSetupPage />;
    }

    return (
        <Show when={!!auth?.user} fallback={<UnauthenticatedRoutes />}>
            <AuthenticatedRoutes />
        </Show>
    );
}
